export const optionActivityCalendarRoutes = {
  optionActivity: { proxy: 'calendar/options-activity', upstream: 'v1/signal/option_activity' },
} as const;
